// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import srchEntity from './entities/srch.json';
import srchMenu from '../pages/srch/menu.json';
import srchFullForm from '../pages/srch/forms/full.json';
import srchContextForm from '../pages/srch/forms/context.json';
import srchMiniForm from '../pages/srch/forms/mini.json';
import srchLookupForm from '../pages/srch/forms/lookup.json';
import srchTableView from '../pages/srch/views/table.json';
import srchStagesView from '../pages/srch/views/stages.json';
import srchCardsView from '../pages/srch/views/cards.json';
import srchInlineView from '../pages/srch/views/inline.json';
import srchBacklogView from '../pages/srch/views/backlog.json';
import srchSplitView from '../pages/srch/views/split.json';
import srchCalendarView from '../pages/srch/views/calendar.json';
import srchDashboardView from '../pages/srch/views/dashboard.json';

/** Тип запису «Область пошуку» зі сторінками пакета: меню, форми та подання з pages/srch/. */
export const srchDefinition: IRecordTypeDefinition = {
  ...srchEntity,
  views: assembleViewSet({
      table: srchTableView,
      stages: srchStagesView,
      cards: srchCardsView,
      inline: srchInlineView,
      backlog: srchBacklogView,
      split: srchSplitView,
      calendar: srchCalendarView,
      dashboard: srchDashboardView,
  }),
  form: srchFullForm,
  forms: { full: srchFullForm, context: srchContextForm, mini: srchMiniForm, lookup: srchLookupForm },
  menu: srchMenu,
} as IRecordTypeDefinition;
